import React from 'react';

import './index.css';
import { SceneController } from './SceneController';

export default class Home extends React.Component {

  componentDidMount() {
    this.threeRootElement.style.outline = 'none';
    this.sceneController = new SceneController(this.threeRootElement);
    this.addEventListeners();
    this.sceneController.setup();
    this.update();
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
    if (this.sceneController) this.sceneController.dispose();
  };

  addEventListeners() {
    window.addEventListener('resize', this.onWindowResize, false);
  };

  onWindowResize = () => {
    if (this.sceneController) {
      this.sceneController.onWindowResize();
      this.sceneController.update();
    }
  };

  update = () => {
    requestAnimationFrame(this.update);
    if (this.sceneController) this.sceneController.update();
  };

  render() {
    return (
      <div className="cssCanvas" ref={element => this.threeRootElement = element}>
        <Text />
      </div>
    );
  }
};

const Text = () => {
  return (
    <div className="Info">
      Liquid Body
      <br />
          Scroll inside
    </div>
  );
}

// const Home = ({ widthScalar, heightScalar }) => {
//   console.log(domRef);
//   const domRef = useRef < HTMLDivElement > (null);
//   let sceneController;

//   const update = () => {
//     requestAnimationFrame(update);
//     sceneController.update();
//   };

//   const addEventListeners = () => {
//     window.addEventListener('resize', handleWindowResize, false);
//     document.addEventListener("mousedown", handleMouseClick, false);
//     document.addEventListener("keydown", handleDocumentKeyDown, false);
//     document.addEventListener("keyup", handleDocumentKeyUp, false);
//   };

//   const handleWindowResize = () => {
//     if (sceneController) {
//       sceneController.onWindowResize();
//       sceneController.update();
//     }
//   };

//   const handleMouseClick = (e) => {
//     if (sceneController) {
//       sceneController.onMouseClick(e);
//     }
//   };

//   const handleDocumentKeyDown = (e) => {
//     if (sceneController) {
//       sceneController.onKeyDown(e);
//     }
//   };

//   const handleDocumentKeyUp = (e) => {
//     if (sceneController) {
//       sceneController.onKeyUp(e);
//     }
//   };

//   const cleanup = () => {
//     sceneController.dispose();
//     window.removeEventListener('resize', handleWindowResize);
//     document.removeEventListener("mousedown", handleMouseClick);
//     document.removeEventListener("keydown", handleDocumentKeyDown);
//     document.removeEventListener("keyup", handleDocumentKeyUp);
//     console.log('cleaning up');
//   };

//   useEffect(() => {
//     console.log('RENDERED FROM INDEX');
//     if (domRef.current) {
//       addEventListeners();
//       domRef.current.style.outline = 'none'; //remove the border around canvas
//       sceneController = new SceneController(widthScalar, heightScalar, domRef.current);
//       update();
//     }

//     return () => {
//       cleanup();
//     };
//   }, [domRef]);

//   return (
//     <>
//       <div ref={domRef} className="cssCanvas" />
//     </>
//   )
// };

// export default Home;
